var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPresent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "2D12AD54-1592-4871-95FF-E3161EB72B64")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-In-close-overlay",
    transform: "translate(-139.000000, -130.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(139.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-participants-checkedin-copy",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,5.7 L4.3,7.1 L7.4,10.3 L13.2,1.7 L11.5,0.6 L7.1,7.2 L5.7,5.7 Z M12.9,4 L11.6,5.9 C11.9,6.4 12,7.1 12,7.7 C12,10.5 9.8,12.7 7,12.7 C4.2,12.7 2,10.5 2,7.7 C2,4.9 4.2,2.7 7,2.7 C7.6,2.7 8.1,2.8 8.7,3 L9.9,1.3 C9,1 8,0.7 7,0.7 C3.1,0.7 0,3.8 0,7.7 C0,11.6 3.1,14.7 7,14.7 C10.9,14.7 14,11.6 14,7.7 C14,6.3 13.6,5.1 12.9,4 Z",
    id: "Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPresent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/present.21746340.svg";
export { ForwardRef as ReactComponent };